import React, {Component} from 'react'
import Select from '../components/Select'
import Field from '../components/Field'
import { trafficSources } from "../actions"

class TrafficRow extends Component {

	constructor(props) {
		super(props)

        this.state = {
            valid:false,
            value:{
                traffic_source:'',
                buyer_name:'',
                buyer_email:''
            },
            required:['traffic_source'],
            focused:false,
            hasError:null,
            message:''
        }
	}

	validate() {
        // Works differently - go through state.required to make sure this passes validation
        if(!this.state.value.traffic_source) {
            this.setState({valid:false, hasError:true})
            this.props.setValid(this.props.id, false)
            return false
        }
        else {
            this.setState({valid:true, hasError:false})
            this.props.setValid(this.props.id, true)
            return true
        }
    }

    updateValue = (i, v) => {
        // this one is different because it's a collection, most go straight back to parent
        var state  = this.state
        state.value[i] = v
        this.setState(state, () => {
            this.props.updateValue(this.props.id, this.state.value)
            this.validate()
        })
    }

    _handleFocus = () => {
        this.setState({focused:true})
    }

    sendRemove = () => {
        this.props.removeRow(this.props.id)
    }
    
	render() {
		return (
            <ul className="form__subList">
                <li className='form__subItem'><Select id='traffic_source' label='Traffic Source' ref={this.props.id} valid={['required']} options={this.props.trafficSources} setValid={this.props.setValid} updateValue={this.updateValue} /></li>
                <li className='form__subItem'><Field id='buyer_name' type={'text'} label='Buyer Name' ref={this.props.id} valid={[]} setValid={this.props.setValid} updateValue={this.updateValue} /></li>
                <li className='form__subItem'><Field id='buyer_email' type={'email'} label='Buyer Email' ref={this.props.id} valid={[]} setValid={this.props.setValid} updateValue={this.updateValue} /></li>
                <li className='form__subItemRemove'><i className="fa fa-minus-circle" onClick={this.sendRemove}></i></li>
            </ul>
		)
	}
}

export default TrafficRow
